import { render } from "./MiGente.vue?vue&type=template&id=32cf275b&ts=true"
import script from "./MiGente.vue?vue&type=script&lang=ts"
export * from "./MiGente.vue?vue&type=script&lang=ts"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__